import { Button, Pagination, Select, Table } from 'antd';
import React from 'react';
import { Link, useLoaderData, useNavigate } from 'react-router-dom';



const columns = [
  {
    title: 'Name',
    dataIndex: 'name',
    key: 'name',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
    // width: '10%'
  },
  {
    title: 'Internal Reference',
    dataIndex: 'internal_reference',
    key: 'internal_reference',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
    // width: '10%'
  },
  {
    title: 'Cost',
    dataIndex: 'cost_price',
    key: 'cost_price',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
    render: (_, record) => <span>{record.cost_price.$numberDecimal}</span>
  },
  
  // {
  //   title: 'Action',
  //   key: 'operation',
  //   // width: '20%',
  //   // fixed: 'right',
  //   className: 'whitespace-nowrap font-medium text-dark-600 dark:text-white',
  //   render: (_, record) => (
  //     <Link className='h-full w-full' to={'/sales/customers/'+record.seo}>
  //       EDIT
  //     </Link>
  //   )
  // }
]




const ExpenseCategories = () => {
  const loader = useLoaderData();
  const navigate = useNavigate();

  const onRow = (record, rowIndex) => {
    return {
      onClick: () => navigate('/expense/expense-categories/'+record.seo)
    };
  };


  return (
    <div>
      <div className='flex justify-between mx-4'>
        <h3 className='font-bold'>Expense Categories</h3>
        <div className=' bg-white dark:bg-gray-900'>
          {/* <Input addonBefore={<MdFilterAlt />}  defaultValue="mysite" /> */}

          <Select
            mode='multiple'
            size={'middle'}
            placeholder='Filter'
            // defaultValue={['a10', 'c12']}
            // onChange={handleChange}
            className='w-96'
            options={[]}
          />
        </div>
      </div>
      <div className='columns-2 mx-4 my-2'>
        <div className='column'>
          <Button className='' size={'sm'}>
            <Link to={'/expense/expense-categories/new'} className='w-full'>New</Link>
          </Button>
        </div>
        <div className='dark:bg-gray-900 column'>
          <div className='flex justify-end'>
            <Pagination total={50} />
          </div>
        </div>
      </div>
      <Table
        rowKey='seo'
        onRow={onRow}
        rowClassName={'hover:cursor-pointer'}
        dataSource={loader}
        columns={columns}
        // scroll={{ x: 1500 }}
        pagination={false}
      />
    
    </div>
  )
}

export default ExpenseCategories;